import { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './tabs-selector.scss';

type Props = ComponentPropsWithRef<'div'>;
export const TabsSelectorWrapper = ({ className, children, ...props }: Props) => {
    return (
        <div className={cn('tabs-selector', className)} {...props}>
            {children}
        </div>
    );
};
